import React from "react"

import { Slide } from "react-slideshow-image"
import "react-slideshow-image/dist/styles.css"

import WPImage, { DISPLAY_MODE } from "./_base/WPImage"

import { ChildSelector } from "../helpers/ChildSelector"

import ComponentFactory from "../components/parsers/ComponentFactory"

import * as simpleMobileNewsSectionStyles from "../styles/SimpleMobileNewsSection.module.css"

export default function SimpleMobileNewsSection(props) {
  const { content } = props

  const contentWrapperProps = {
    className: "simples-news-section",
    pageContext: props.pageContext,
    modals: props.modals,
  }
  const components = ComponentFactory(content.innerHTML, contentWrapperProps)

  const title = ChildSelector.select(
    content,
    `news-section-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const newsItems = components.props.children
    .filter(
      c =>
        c.props.content &&
        c.props.content.classNames.trim().split(/\s+/).includes(`cw-news`),
    )
    .map((elem, idx) => ({ originalIndex: idx, newsItem: elem }))

  return (
    <div
      className={`row ${props.className} ${simpleMobileNewsSectionStyles.wrapper}`}
    >
      <div className={`col-12  ${simpleMobileNewsSectionStyles.titleWrapper}`}>
        <div className={`row`}>
          <div className={`col-12 ${simpleMobileNewsSectionStyles.title}`}>
            {title}
          </div>
        </div>
      </div>

      <div
        className={`col-12  ${simpleMobileNewsSectionStyles.contentWrapper}`}
      >
        <div className={`row`}>
          <Slide
            easing="cubic"
            cssClass={simpleMobileNewsSectionStyles.sliderWrapper}
            autoplay={false}
            infinite={false}
          >
            {newsItems &&
              newsItems.map((slider, idx) => (
                <div
                  key={idx}
                  className={simpleMobileNewsSectionStyles.eachSlideEffect}
                >
                  {slider.newsItem}
                  <div
                    className={`row d-none d-lg-flex justify-content-center ${simpleMobileNewsSectionStyles.newsImageHolder}`}
                  >
                    <WPImage
                      holder={slider.newsItem.props.content}
                      selector={`news-image`}
                      mode={DISPLAY_MODE.inline}
                      className={`col-12 justify-content-center image-holder`}
                    />
                  </div>
                </div>
              ))}
          </Slide>
        </div>
      </div>
    </div>
  )
}
